import {PaginatedParams, PaginatedResponse} from '@/api/base.api';
import {Observable} from 'rxjs';
import {InvitationMode, InvitationsModel, InvitationStatus, TeamModel} from '@/models/team.model';
import {axiosInstance, axiosInstanceAuthenticated} from '@/api/axios.config.api';
import {map} from 'rxjs/operators';

export class UserTeamsApi {

  fetchMyTeams(slug: string, params?: PaginatedParams): Observable<PaginatedResponse<TeamModel>> {
    return axiosInstance().get<PaginatedResponse<TeamModel>>(`/users/${slug}/teams`, {params})
      .pipe(map((response) => response.data))
  }

  allInvitations(params: PaginatedParams,
                 mode?: InvitationMode,
                 status?: InvitationStatus): Observable<PaginatedResponse<InvitationsModel>> {
    const url = 'profile/teams/invitations';
    return axiosInstanceAuthenticated().get(url, {
      params: {
        ...params,
        'filter[mode]': mode,
        'filter[status]': status,
      }
    }).pipe(map((response) => response.data))
  }

  refuseInvitation(challengeId: number, teamId: number, inviteId: number) {
    const url = `challenges/${challengeId}/teams/${teamId}/contestant/invites/${inviteId}/reject`;
    return axiosInstanceAuthenticated().put(url, {})
      .pipe(map((response) => response.data))
  }

  acceptInvitation(challengeId: number, teamId: number, inviteId: number): Observable<any> {
    const url = `challenges/${challengeId}/teams/${teamId}/contestant/invites/${inviteId}/accept`;
    return axiosInstanceAuthenticated().put(url, {})
      .pipe(map((response) => response.data))
  }
}
